import React from "react";
import {
  Container,
  Hidden,
  useMediaQuery,
  SwipeableDrawer,
  Button,
  List,
  ListItem,
  ListItemText,
  Box,
  Paper,
  ListItemButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import clsx from "clsx";
import { logo } from "./SmallComponents/Images";

// import { AppContext } from "../utils";
import { StyledNavButton, StyledText } from "./SmallComponents/AppComponents";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
    alignItems: "center",
  },
  paper: {
    background: "#27ADFB !important",
  },
  hover: {
    "&:hover": {
      color: "#FFB800",
    },
  },
});

const navArray = [
  {
    text: "Home",
    link: "/#home",
  },
  {
    text: "About",
    link: "/#about",
  },
  {
    text: "Token Info",
    link: "/#tokenomics",
  },
  {
    text: "How to Buy",
    link: "/#buy",
  },
  {
    text: "Staking",
    link: "https://stake.barfboymemecoin.com/",
  },
  {
    text: "Whitepaper",
    link: "/whitepaper.pdf",
    target: "_blank",
  },
];

export default function Header() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });
  const matches1 = useMediaQuery("(max-width:1279px)");

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box display="flex" justifyContent="center" my={2}>
        <Link to={"/"} style={{ textDecoration: "none" }}>
          <img width="80px" src={logo} style={{ borderRadius: "50%" }} alt="" />
        </Link>
      </Box>
      <List>
        {navArray?.map(({ text, link, target }) => (
          <ListItemButton key={text}>
            <HashLink
              smooth
              to={link}
              target={target}
              style={{
                textDecoration: "none",
                margin: "auto",
              }}
            >
              <ListItemText
                sx={{
                  textTransform: "capitalize",
                  textAlign: "center",
                  textDecoration: "none",
                  cursor: "pointer",

                  color: "#ffffff",
                  ".MuiTypography-root": {
                    fontFamily: "Montserrat",
                  },
                }}
                primary={text}
              />
            </HashLink>
          </ListItemButton>
        ))}
      </List>
      <Box mt={2} display="flex" justifyContent="center">
        <Link
          to="https://stake.barfboymemecoin.com/"
          style={{ textDecoration: "none" }}
        >
          <StyledNavButton width="150px">Enter DAPP</StyledNavButton>
        </Link>
      </Box>
    </div>
  );
  return (
    <>
      <Box
        sx={{
          background: "transparent",
        }}
        height="92px"
        width="100%"
        py={1.5}
      >
        <Container maxWidth="xl">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Link to={"/"} style={{ textDecoration: "none" }}>
              <Box
                component={"img"}
                width={{ xs: "90px", md: "130px" }}
                style={{ borderRadius: "50%" }}
                src={logo}
                alt=""
              />
            </Link>
            <Box
              display="flex"
              justifyContent={matches1 ? "end" : "space-between"}
              alignItems="center"
            >
              <Hidden mdDown>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    pl: 2.5,
                    pr: 1,
                    borderRadius: "84px",
                    background: "#27ADFB",
                    boxShadow:
                      "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
                  }}
                >
                  {navArray?.map(({ text, link, target }) => (
                    <HashLink
                      key={text}
                      smooth
                      to={link}
                      target={target}
                      style={{ textDecoration: "none" }}
                    >
                      <StyledText mr={4}>{text}</StyledText>
                    </HashLink>
                  ))}
                  <Link
                    to={"https://stake.barfboymemecoin.com/"}
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <StyledNavButton width="160px" height="60px">
                      Enter dAPP
                    </StyledNavButton>
                  </Link>
                </Box>
              </Hidden>

              <Hidden mdUp>
                {["left"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    <Button
                      onClick={toggleDrawer(anchor, true)}
                      style={{
                        background: "#27ADFB",
                        minWidth: "50px",
                        minHeight: "50px",
                        padding: "4px 0px",
                        zIndex: 1,
                        borderRadius: "5px",
                        boxShadow:
                          "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
                      }}
                    >
                      <MenuIcon
                        style={{
                          fontSize: "34px",
                          cursor: "pointer",
                          color: "#ffffff",
                        }}
                      />{" "}
                    </Button>
                    <Paper>
                      <SwipeableDrawer
                        classes={{ paper: classes.paper }}
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                      >
                        {list(anchor)}
                      </SwipeableDrawer>
                    </Paper>
                  </React.Fragment>
                ))}
              </Hidden>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}
